import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';
import { getImageBasePath } from 'utils/generics';
import { IData, IHeader } from '../types';

interface TableHeader {
    key: string;
    name: string;
}

const TableContainer = styled.div`
    margin: 40px auto;
    border: 1px solid #ddd;
    border-radius: 8px;
    width: 100%;
    overflow: scroll;
`;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

const TableHeader = styled.th`
    background-color: #f4f4f4;
    padding: 12px;
    text-align: center;
    font-weight: bold;
    border-bottom: 2px solid #ddd;
`;

const TableRow = styled.tr`
    &:nth-child(even) {
        background-color: #f9f9f9;
    }
`;

const TableData = styled.td`
    padding: 8px;
    border-bottom: 1px solid #ddd;
    text-align: center;
    text-wrap: nowrap;
`;

const Pagination = styled.div`
    display: flex;
    justify-content: center;
    padding: 16px;
    align-items: center;
`;

const PageButton = styled.button`
    margin: 0 5px;
    padding: 4px 6px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        color: #aaa;
    }
`;

const NoResult = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-top: 20px;
`;

interface IProps {
    headers: IHeader[];
    data: IData[];
    totalPages: number;
    onNext: () => void;
    onBack: () => void;
    currentPage: number;
}

const PaginatedTable: React.FC<IProps> = (props) => {
    const { headers, data, totalPages, onNext, onBack, currentPage } = props;

    return (
        <>
            {data.length === 0 ? (
                <NoResult>No commissions</NoResult>
            ) : (
                <>
                    <TableContainer>
                        <StyledTable>
                            <thead>
                                <tr>
                                    {headers.map((header) => (
                                        <TableHeader key={header.key}>
                                            {header.name}
                                        </TableHeader>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <TableRow key={index}>
                                        {headers.map((header) => (
                                            <TableData key={header.key}>
                                                {
                                                    item[
                                                        header.key as keyof IData
                                                    ]
                                                }
                                            </TableData>
                                        ))}
                                    </TableRow>
                                ))}
                            </tbody>
                        </StyledTable>
                    </TableContainer>

                    <Pagination>
                        <PageButton
                            onClick={onBack}
                            disabled={currentPage === 1}
                            hidden={currentPage === 1}
                        >
                            <Image
                                src={getImageBasePath('/icons/backArrow.svg')}
                                alt="Previous"
                                width={'20px'}
                                height={'20px'}
                            />
                        </PageButton>
                        <span>
                            {currentPage} / {totalPages}
                        </span>
                        <PageButton
                            onClick={onNext}
                            disabled={currentPage === totalPages}
                            hidden={currentPage === totalPages}
                        >
                            <Image
                                src={getImageBasePath('/icons/backArrow.svg')}
                                alt="Previous"
                                width={'20px'}
                                height={'20px'}
                                style={{ rotate: '180deg' }}
                            />
                        </PageButton>
                    </Pagination>
                </>
            )}
        </>
    );
};

export default PaginatedTable;
